import { useCallback, useState } from 'react';
import { UserContextProps } from './AuthUserContext';
import { useTypedQuery } from 'src/utils/hooks/useTypedQuery';
import { GetInitialInfoDocument } from './__generated__/GetInitialInfo.graphql';
import { AuthUser } from './AuthUserModels';

export function useAuthUser(initialUser: AuthUser | undefined): UserContextProps {
  const [user, setUser] = useState<AuthUser | undefined>(initialUser);

  const { get: getUserQuery } = useTypedQuery(GetInitialInfoDocument, {
    onCompleted: (result) => setUser(result.self as AuthUser)
  });

  const refresh = useCallback(() => {
    getUserQuery();
  }, [getUserQuery]);

  const updateUser = useCallback((user: DeepPartial<AuthUser>) => {
    setUser(
      (prevUser) =>
        ({
          ...prevUser,
          ...user
        }) as AuthUser
    );
  }, []);

  const updateUserDateTimeFormatConfig = useCallback(
    async (dateTimeFormatConfig: AuthUser['preferences']['dateTimeFormatConfig']) => {
      if (!user) return;

      setUser({
        ...user,
        preferences: {
          ...user.preferences,
          dateTimeFormatConfig
        }
      });
    },
    [user]
  );

  return {
    user,
    refresh,
    updateUserDateTimeFormatConfig,
    updateUser
  };
}
